import { UiZoneWidgetConfig, WorkflowWidgetConfig } from '@finxone-platform/shared/sys-config-types';

export const mapProfileWidgetFunction = function mapProfileWidgetFunction(
  item: WorkflowWidgetConfig,
): UiZoneWidgetConfig {
  return {
    attributes: {
      ...item.widgetConfiguration.attributes,
    },
    name: item.name,
    gridPosition: item.gridPosition,
    uniqueId: item.uniqueId,
  } as UiZoneWidgetConfig;
};
